import { ServiceLocation } from 'src/api/@generated/backend-api';

import { resetStateForNewServiceLocationActionCreator } from 'src/state/address/action-creators/reset-state-for-new-service-location-action-creator';
import { setServiceLocation } from 'src/state/address/address-slice';
import { AppDispatch, RootState } from 'src/state/types';

export const selectServiceLocationActionCreator =
  (serviceLocation: ServiceLocation) => (dispatch: AppDispatch, getState: () => RootState) => {
    const {
      address: { selectedServiceLocation },
    } = getState();

    if (selectedServiceLocation && selectedServiceLocation.siteId !== serviceLocation.siteId) {
      dispatch(resetStateForNewServiceLocationActionCreator());
    }

    dispatch(setServiceLocation(serviceLocation));
  };
